import { __assign, __extends } from "tslib";
/* I63 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Dino = /** @class */ (function (_super) {
    __extends(Dino, _super);
    function Dino() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dino.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { viewBox: "0 0 147 183", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { fill: "none", fillRule: "evenodd" },
                    React.createElement("path", { d: "M29 48h88v88H29z" }),
                    React.createElement("path", { fill: "#0D0E0F", d: "M96.1 25v5.495h-5.797v49.797h-28.86v5.154h-5.437v5.72h-6.034v5.269h-5.553v5.72h-5.797v5.637h-5.796v9.385h-5.704v6.868H23.5v5.495h-7.82v10.758H10v10.753h22.56v-5.676h5.865v11.654h28.936v-11.654h22.942v11.654h22.765V129.1h6.217V63.28h6.074v-5.472h6.144v-5.27h5.431V41.49h-5.431v-5.27h-6.144v-5.955h-6.074V25z" })))));
    };
    return Dino;
}(React.Component));
export { Dino };
export default Dino;
//# sourceMappingURL=Dino.js.map